import { useState, useCallback } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import type {
  CheckAvailabilityPayload,
  CheckAvailabilityResponse,
  AvailableRoomType,
} from "@/types/booking";

export function useAvailability() {
  const [available, setAvailable] = useState<AvailableRoomType[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searched, setSearched] = useState(false);

  const checkAvailability = useCallback(
    async (payload: CheckAvailabilityPayload) => {
      setLoading(true);
      setError(null);
      setSearched(false);

      try {
        const functions = getFunctions(undefined, "asia-south1");
        const fn = httpsCallable<
          CheckAvailabilityPayload,
          CheckAvailabilityResponse
        >(functions, "checkAvailability");

        const result = await fn(payload);
        setAvailable(result.data.available);
        setSearched(true);
      } catch (err) {
        console.error("Availability check failed:", err);
        setError("Failed to check availability. Please try again.");
        setAvailable([]);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const reset = useCallback(() => {
    setAvailable([]);
    setError(null);
    setSearched(false);
  }, []);

  return { available, loading, error, searched, checkAvailability, reset };
}